module.exports = __webpack_public_path__ + "assets/images/template-1.d523764d933d375c3adeee5b3c51e87a.png";